// constants.js

export const API_TOKEN = process.env.REACT_APP_API_TOKEN

// export const baseApiUrl = 'https://recipes.greyling.info/api/v2'
// export const baseApiUrl = 'https://recipeapi.greyling.tech/api/v2'
// export const baseApiUrl = 'http://localhost:3578/api/v2'
export const baseApiUrl = process.env.NODE_ENV === 'development'
    ? 'http://localhost:3578/api/v2'
    : process.env.NODE_ENV === 'production'
        ? 'https://recipeapi.greyling.tech/api/v2'
        : null

export const ApiEndpoint = {
    urlRecipes: `${baseApiUrl}/recipes`,
    urlRecipe: `${baseApiUrl}/recipe`,
    urlByIngred: `${baseApiUrl}/by-ingredient`,
    urlSearch: `${baseApiUrl}/search`,
}

export const axiosHeaders = {
    headers: {
      Authorization: `Basic ${API_TOKEN}`
    }
}